import { UndefinedOption } from '@df/ui/atomic/atomic-options';
import { NICmsContentField } from '@icms/core/content';
import { ICONS_CODEPOINTS } from '../../../../../styles/icons';
/**
 * Grid size options list
 */
export const GridSizeOptions: NICmsContentField.IOption[] = [
    { key: 12, title: '1' },
    { key: 6, title: '2' },
    { key: 4, title: '3' },
    { key: 3, title: '4' },
    { key: 2, title: '6' },
    { key: 1, title: '12' }
];
const icons = Object.keys(ICONS_CODEPOINTS).map(iconKey => {
    return {
        key: `icon-${iconKey}`,
        title: iconKey
    };
});
export const IconsOptions: NICmsContentField.IOption[] = [...UndefinedOption, ...icons];
